import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { AppReducer } from "./slices/app.slice";
import { AuthSliceReducer } from "./slices/auth.slice";
import { CurrentUserSliceReducer } from "./slices/current-user.slice";
import { HiddenUserMessagesReducer } from "./slices/hidden-user-messages.slice";
import { LastAnswerReducer } from "./slices/last-answer.slice";
import { ProgressBarReducer } from "./slices/progress-bar.slice";

const appPersistConfig = {
	key: "app-reducer",
	storage,
};

const hiddenMessagePersistConfig = {
	key: "hidden-messaage-reducer",
	storage,
};

const lastAnswerPersistConfig = {
	key: "last-answer-reducer",
	storage,
};

const persistedAppReducer = persistReducer(appPersistConfig, AppReducer);
const persistedHiddenMessageReducer = persistReducer(
	hiddenMessagePersistConfig,
	HiddenUserMessagesReducer,
);
const persistedLastAnswer = persistReducer(lastAnswerPersistConfig, LastAnswerReducer);

export const ReduxStore = configureStore({
	reducer: {
		auth: AuthSliceReducer,
		currentUser: CurrentUserSliceReducer,
		progressBar: ProgressBarReducer,
		hiddenUserMessages: persistedHiddenMessageReducer,
		app: persistedAppReducer,
		lastAnswer: persistedLastAnswer,
	},
});

export const Persistor = persistStore(ReduxStore);

export type ReduxState = ReturnType<typeof ReduxStore.getState>;
export type TypedDispatch = typeof ReduxStore.dispatch;

export const useTypedDispatch: () => TypedDispatch = useDispatch;
export const useTypedSelector: TypedUseSelectorHook<ReduxState> = useSelector;
